module.exports = __webpack_public_path__ + "img/IMG_6070_L_WoodMatted_MockedUp.ebb49821.jpg";